export default __webpack_public_path__ + "static/media/gunshot.9a537ae5.mp3";